import { Modal, Stack, Text, Button, Group, Loader, ThemeIcon, Box } from '@mantine/core';
import { IconSparkles, IconBook, IconArrowRight } from '@tabler/icons-react';

interface StoryGeneratingModalProps {
  opened: boolean;
  onClose: () => void;
  onCreateAnother: () => void;
  onGoToLibrary: () => void;
  themeName?: string;
  isWaiting?: boolean;
}

export function StoryGeneratingModal({
  opened,
  onClose,
  onCreateAnother,
  onGoToLibrary,
  themeName,
  isWaiting = false,
}: StoryGeneratingModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="teal">
            <IconSparkles size={20} />
          </ThemeIcon>
          <Text fw={600}>Story Generation in Progress</Text>
        </Group>
      }
      centered
      size="md"
    >
      <Stack gap="lg">
        <Box ta="center" py="md">
          <Loader size="lg" type="dots" color="teal" />
        </Box>

        <Stack gap="sm">
          <Text size="sm" c="dimmed" ta="center">
            {themeName && (
              <>
                We're creating your <Text span fw={500} c="teal">"{themeName}"</Text> story
              </>
            )}
            {!themeName && "We're creating your story"}
          </Text>
          <Text size="sm" c="dimmed" ta="center">
            This usually takes 15-30 seconds. You'll receive a notification when it's ready.
          </Text>
        </Stack>

        <Stack gap="xs">
          {isWaiting ? (
            <Text size="sm" c="dimmed" ta="center" fs="italic">
              Waiting for your story to complete...
            </Text>
          ) : (
            <>
              <Button
                variant="light"
                leftSection={<IconSparkles size={16} />}
                onClick={onCreateAnother}
                fullWidth
              >
                Create Another Story
              </Button>

              <Button
                variant="subtle"
                leftSection={<IconBook size={16} />}
                onClick={onGoToLibrary}
                fullWidth
              >
                Go to Library
              </Button>
            </>
          )}
        </Stack>

        {!isWaiting && (
          <Text size="xs" c="dimmed" ta="center">
            You can navigate away - we'll notify you when ready
          </Text>
        )}
      </Stack>
    </Modal>
  );
}
